import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import AppShell from "./components/layout/AppShell";
import NotAuthorised from "./NotAuthorised";
import { clearAuthCookies, isTokenExpiringSoon, refreshAuthSession } from "./utilities/authUtils";

const ProtectedRoute = () => {
  const navigate = useNavigate();
  const [sessionToken, setSessionToken] = useState(Cookies.get("jwtToken"));

  useEffect(() => {
    const validateSession = async () => {
      if (!sessionToken) {
        try {
          const refreshed = await refreshAuthSession();
          if (refreshed?.jwt_token) {
            setSessionToken(refreshed.jwt_token);
          } else {
            navigate("/");
          }
        } catch (error) {
          clearAuthCookies();
          navigate("/");
        }
        return;
      }

      if (isTokenExpiringSoon(sessionToken, 0)) {
        try {
          const refreshed = await refreshAuthSession();
          if (refreshed?.jwt_token) {
            setSessionToken(refreshed.jwt_token);
          }
        } catch (error) {
          clearAuthCookies();
          navigate("/");
        }
      }
    };

    validateSession();
  }, [navigate, sessionToken]);

  if (!sessionToken) {
    return null;
  }

  try {
    const decodedToken = jwtDecode(sessionToken);
    if (decodedToken.Role !== "Admin") {
      return <NotAuthorised />;
    }
  } catch (error) {
    return <NotAuthorised />;
  }

  return <AppShell />;
};

export default ProtectedRoute;
